import { Button } from "@arcadeai/design-system/components/ui/atoms/button";
import { Link } from "@tanstack/react-router";
import type { Row } from "@tanstack/react-table";
import { Eye, Play } from "lucide-react";
import { CanProject } from "@/app/capabilities/components/can-project";
import { PROJECT } from "@/app/capabilities/permissions";
import { extractToolName } from "@/app/tools/utils";
import type { Tool } from "../types";
import { ToolDetailsSheet } from "./tool-details-sheet";

type DataTableRowActionsProps = {
  row: Row<Tool>;
};

export function DataTableRowActions({ row }: DataTableRowActionsProps) {
  const tool = row.original;

  return (
    <div className="flex items-center justify-start gap-2">
      <ToolDetailsSheet
        tool={tool}
        trigger={
          <Button size="sm" variant="secondary">
            <Eye />
            <span className="hidden md:block">View</span>
          </Button>
        }
      />
      <CanProject permission={PROJECT.tools.execute}>
        <Link
          from="/orgs/$organizationId/projects/$projectId/playground/execute"
          search={{ toolId: extractToolName(tool) }}
          to="."
        >
          <Button size="sm" variant="secondary">
            <Play className="size-4" />
            <span className="hidden md:block">Execute</span>
          </Button>
        </Link>
      </CanProject>
    </div>
  );
}
